import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {AxiosError} from "axios";
import useApi from "../../../utils/custom-hooks/api-hooks/useApi";
import {IEstimate} from "../../../utils/interfaces/Estimate/IEstimate";


const useApiGetEstimate = (pk: number | undefined): UseQueryResult<IEstimate, AxiosError> => {
    const {get} = useApi()

    async function doGet(pk: number | undefined): Promise<IEstimate> {
        try {
            const response = await get(`/estimates/${pk}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetEstimate", pk],
        queryFn: () => doGet(pk),
        enabled: !!pk
    })
};

export default useApiGetEstimate
